import { PDFViewer } from "@react-pdf/renderer";
import { ReportPDF } from "./ReportPDF";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Download, X } from "lucide-react";
import { pdf } from "@react-pdf/renderer";
import { useToast } from "@/hooks/use-toast";

interface ReportPDFPreviewProps {
  report: any;
  branding?: any;
  isOpen: boolean;
  onClose: () => void;
  sessionId: string;
  sessionMeta?: any;
}

export const ReportPDFPreview = ({
  report,
  branding,
  isOpen,
  onClose,
  sessionId,
  sessionMeta,
}: ReportPDFPreviewProps) => {
  const { toast } = useToast();

  const handleDownload = async () => {
    try {
      toast({
        title: "PDF wird erstellt",
        description: "Bitte warten Sie einen Moment...",
      });

      const blob = await pdf(<ReportPDF report={report} branding={branding} sessionMeta={sessionMeta} />).toBlob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `decision-report-${sessionId}.pdf`;
      link.click();
      URL.revokeObjectURL(url);

      toast({
        title: "PDF erstellt",
        description: "Der Report wurde als PDF heruntergeladen.",
      });
    } catch (error) {
      console.error("Error downloading PDF:", error);
      toast({
        title: "Fehler",
        description: "Der PDF-Download ist fehlgeschlagen.",
        variant: "destructive",
      });
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-7xl h-[90vh] p-0">
        <DialogHeader className="px-6 py-4 border-b">
          <div className="flex items-center justify-between">
            <DialogTitle>PDF-Vorschau</DialogTitle>
            <div className="flex items-center gap-2">
              <Button onClick={handleDownload} size="sm">
                <Download className="h-4 w-4 mr-2" />
                Herunterladen
              </Button>
              <Button variant="ghost" size="sm" onClick={onClose}>
                <X className="h-4 w-4" />
              </Button>
            </div>
          </div>
        </DialogHeader>
        <div className="flex-1 overflow-hidden">
          <PDFViewer width="100%" height="100%" showToolbar={true}>
            <ReportPDF report={report} branding={branding} sessionMeta={sessionMeta} />
          </PDFViewer>
        </div>
      </DialogContent>
    </Dialog>
  );
};
